import * as React from "react";
import SvgIcon from "@mui/material/SvgIcon";

export function FlagEnIcon(props) {
    return (
        <SvgIcon {...props}>
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                <defs>
                    <clipPath id="clip-path">
                        <circle
                            id="Ellipse_3"
                            data-name="Ellipse 3"
                            cx="12"
                            cy="12"
                            r="12"
                            transform="translate(0 0)"
                            fill="none"
                        />
                    </clipPath>
                </defs>
                <g id="Group_690" data-name="Group 690" transform="translate(0 0)" clipPath="url(#clip-path)">
                    <rect
                        id="Rectangle_124"
                        data-name="Rectangle 124"
                        width="48"
                        height="24"
                        transform="translate(-11.94 0)"
                        fill="#fff"
                    />
                    <path
                        id="Path_1093"
                        data-name="Path 1093"
                        d="M-27.977-92.9h-21.6v-9.6h-4.8v9.6h-21.6v4.8h21.6v9.6h4.8v-9.6h21.6"
                        transform="translate(64.037 102.5)"
                        fill="#c2000e"
                    />
                    <path
                        id="Path_1094"
                        data-name="Path 1094"
                        d="M-43.977-86.5H-40.4l12.422,6.211V-78.5m-32-16h-3.578l-12.422-6.211V-102.5Zm0,8H-56.4l-16,8h-3.578Zm16-8h-3.578l16-8h3.578Z"
                        transform="translate(64.037 102.5)"
                        fill="#c2000e"
                    />
                    <path
                        id="Path_1095"
                        data-name="Path 1095"
                        d="M-75.977-86.5v5.317L-65.343-86.5m37.367,0v5.317L-38.61-86.5Zm-48-8v-5.317L-65.343-94.5Zm48,0v-5.317L-38.61-94.5Zm-28,16v-7.317L-70.61-78.5Zm8,0v-7.317L-33.343-78.5Zm-8-24v7.317L-70.61-102.5Zm8,0v7.317l14.634-7.317Z"
                        transform="translate(64.037 102.5)"
                        fill="#002549"
                    />
                </g>
            </svg>
        </SvgIcon>
    );
}

export function FlagPlIcon(props) {
    return (
        <SvgIcon {...props}>
            <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512">
                <mask id="circleFlagsPl0">
                    <circle cx="256" cy="256" r="256" fill="#fff" />
                </mask>
                <g mask="url(#circleFlagsPl0)">
                    <path fill="#d80027" d="m0 256l256.4-44.3L512 256v256H0z" />
                    <path fill="#eee" d="M0 0h512v256H0z" />
                </g>
            </svg>
        </SvgIcon>
    );
}
